import $ from 'jquery';

const formValidation = {
  initValidationFix: () => {
    // Listen for change on form controls
    $('.wpcf7-form').on('change', '.wpcf7-form-control', function () {
      // If not-valid-tip exists and input does not have an empty value:
      if ($('.wpcf7-not-valid-tip', $(this).parent()).length && $(this).val() !== '') {
        // Remove the hidden aria message
        $('.wpcf7-not-valid-tip', $(this).parent()).remove();
        // Remove the not-valid class
        $(this).removeClass('wpcf7-not-valid');
      }
    });
  },
};

export default formValidation;
